"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumeSchema = void 0;
const zod_1 = require("zod");
/**
 * JSON Resume schema (zod strict)
 * Based on https://jsonresume.org/schema/
 * Champs Prisma sans équivalent JSON Resume → droppés
 */
const BasicsSchema = zod_1.z.object({
    name: zod_1.z.string(),
    label: zod_1.z.string().optional(),
    image: zod_1.z.string().optional(),
    email: zod_1.z.string().email(),
    phone: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
    location: zod_1.z
        .object({
        city: zod_1.z.string().optional(),
        region: zod_1.z.string().optional(),
        countryCode: zod_1.z.string().optional(),
    })
        .optional(),
    driverLicense: zod_1.z.string().optional(),
    openToTraining: zod_1.z.boolean().optional(),
    profiles: zod_1.z
        .array(zod_1.z.object({
        network: zod_1.z.string(),
        username: zod_1.z.string(),
        url: zod_1.z.string().optional(),
    }))
        .optional(),
});
const WorkSchema = zod_1.z.object({
    name: zod_1.z.string(),
    position: zod_1.z.string().optional(),
    company: zod_1.z.string().optional(),
    location: zod_1.z.string().optional(),
    startDate: zod_1.z.string().optional(),
    endDate: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
    highlights: zod_1.z.array(zod_1.z.string()).optional(),
});
const EducationSchema = zod_1.z.object({
    institution: zod_1.z.string().optional(),
    area: zod_1.z.string().optional(),
    studyType: zod_1.z.string().optional(),
    location: zod_1.z.string().optional(),
    startDate: zod_1.z.string().optional(),
    endDate: zod_1.z.string().optional(),
    score: zod_1.z.string().optional(),
    courses: zod_1.z.array(zod_1.z.string()).optional(),
});
const VolunteerSchema = zod_1.z.object({
    organization: zod_1.z.string().optional(),
    position: zod_1.z.string().optional(),
    website: zod_1.z.string().optional(),
    location: zod_1.z.string().optional(),
    startDate: zod_1.z.string().optional(),
    endDate: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
    highlights: zod_1.z.array(zod_1.z.string()).optional(),
});
const ProjectSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    highlights: zod_1.z.array(zod_1.z.string()).optional(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
    startDate: zod_1.z.string().optional(),
    endDate: zod_1.z.string().optional(),
    url: zod_1.z.string().optional(),
    roles: zod_1.z.array(zod_1.z.string()).optional(),
    entity: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(),
});
const AwardSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    date: zod_1.z.string().optional(),
    awarder: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
});
const CertificateSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    date: zod_1.z.string().optional(),
    issuer: zod_1.z.string().optional(),
    url: zod_1.z.string().optional(),
});
const PublicationSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    publisher: zod_1.z.string().optional(),
    releaseDate: zod_1.z.string().optional(),
    website: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
});
const ReferenceSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    reference: zod_1.z.string().optional(),
});
const SkillSchema = zod_1.z.object({
    name: zod_1.z.string(),
    level: zod_1.z.string().optional(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
});
const LanguageSchema = zod_1.z.object({
    language: zod_1.z.string(),
    fluency: zod_1.z.string().optional(),
});
const InterestSchema = zod_1.z.object({
    name: zod_1.z.string(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.ResumeSchema = zod_1.z.object({
    basics: BasicsSchema,
    work: zod_1.z.array(WorkSchema).optional(),
    volunteer: zod_1.z.array(VolunteerSchema).optional(),
    education: zod_1.z.array(EducationSchema).optional(),
    awards: zod_1.z.array(AwardSchema).optional(),
    certificates: zod_1.z.array(CertificateSchema).optional(),
    publications: zod_1.z.array(PublicationSchema).optional(),
    skills: zod_1.z.array(SkillSchema).optional(),
    languages: zod_1.z.array(LanguageSchema).optional(),
    interests: zod_1.z.array(InterestSchema).optional(),
    references: zod_1.z.array(ReferenceSchema).optional(),
    projects: zod_1.z.array(ProjectSchema).optional(),
});
